import React from 'react';
import PropTypes from 'prop-types';

import { MarkdownView } from 'site-modules/shared/components/markdown-view/markdown-view';
import { applyTemplateParams } from 'site-modules/shared/components/lead-form/utils/utils';

/**
 * Lead Form Markdown View
 * @param markdown
 * @param className
 * @param templateParams, params: [{ name: 'name', value: 'John' }] and  markdown: 'Hello {name}' will be converted to 'Hello John',
 */
export function LeadFormMarkdownView({ markdown = '', className = '', templateParams = [] }) {
  const markdownText = applyTemplateParams(templateParams, markdown);
  return <MarkdownView className={className} markdown={markdownText} />;
}

LeadFormMarkdownView.propTypes = {
  markdown: PropTypes.string,
  className: PropTypes.string,
  templateParams: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ),
};
